import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tInvtModel, StockManagementClass, tInvtModel_PrintModel, tInvtItemCostModel, tInvtModelOnHand,BatchNumberEnquiryMediModel,BatchNumberEnquiryModel } from '../models/tInvtModel';



@Injectable({
    providedIn: 'root'
})

export class tInvtService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tInvt';

    getAllData() {
        return this.http.get<tInvtModel[]>(this.baseurl + this.pathName);
    }

    getOnHand(shopID: string, stockDate: string, data: any) {
        return this.http.post<tInvtModelOnHand[]>(this.baseurl + this.pathName + '/GetOnHand/'
        + shopID + '/' + stockDate, data);
    }
    getBatchNumnber(shopID: string, data: any) {
        return this.http.post<BatchNumberEnquiryModel[]>(this.baseurl + this.pathName + '/GetBatchNumnber/'
        + shopID, data);
    }

    GetBatchNumnberBarCode(shopID: string, barCode:string) {
        return this.http.get<BatchNumberEnquiryMediModel[]>(this.baseurl + this.pathName + '/GetBatchNumnberBarCode/'
        + shopID+'/'+barCode);
    }


    getOnHandByWH(shopID: string, stockDate: string, data: any) {
        return this.http.post<tInvtModelOnHand[]>(this.baseurl + this.pathName + '/GetOnHandByWH/'
        + shopID + '/' + stockDate, data);
    }

    getInvtRecord(shopID: string) {
        return this.http.get<StockManagementClass[]>(this.baseurl + this.pathName + '/GetInvtRecord/' + shopID);
    }

    getInvtRecordBySubType(shopID: string, subType: number) {
        return this.http.get<StockManagementClass[]>(this.baseurl + this.pathName
            + '/GetInvtRecordByinvtSubType/' + shopID + '/' + subType);
    }

    getInvtRecordBySubTypeSearch(shopID: string, subType: number, data: any) {
        return this.http.post<StockManagementClass[]>(this.baseurl + this.pathName
            + '/getInvtRecordBySubTypeSearch/' + shopID + '/' + subType, data);
    }

    postMultiRecord(data: tInvtModel[]) {
        return this.http.post(this.baseurl + this.pathName + '/PostMultiRecord', data);
    }

    deleteStockDataByDocNumber(shopID: string, invtDocNumber: string) {
        return this.http.delete(this.baseurl + this.pathName + '/DeleteData/' + shopID + '/' + invtDocNumber);
    }

    getDataByinvtDocNumber(shopID: string, docNumber: string) {
        return this.http.get<tInvtModel[]>(this.baseurl + this.pathName + '/GetDataByinvtDocNumber/' + shopID + '/' + docNumber);
    }

    getPrintDataByinvtDocNumber(shopID: string, docNumber: string) {
        return this.http.get<tInvtModel_PrintModel>(this.baseurl + this.pathName
            + '/GetPrintDataByinvtDocNumber/' + shopID + '/' + docNumber);
    }


    updateChangeMultiRecord_byDocNumber(data: tInvtModel[], docNumber: string) {
        return this.http.post(this.baseurl + this.pathName + '/updateChangeMultiRecord_byDocNumber/' + docNumber, data);
    }

    getItemCost(shopID: string, itemType: number , itemID: string) {
        return this.http.get<tInvtItemCostModel>(this.baseurl + this.pathName
            + '/GetItemCost/' + shopID + '/' + itemType + '/' + itemID);
    }

}
